import { useState } from "react"

type RatingStarProps = {
    starNumber: number;
    starCount: number;
    isMobileLayout: boolean;    
    color?: string;
    highlight?: boolean;
}

export const RatingStar = ({starNumber, starCount, isMobileLayout, color, highlight = false} : RatingStarProps) => {

    console.log("[RatingStar] isMobile: ", isMobileLayout);
    
    return (
        <svg 
            key={"star-" + starNumber}
            // style={color ? {fill: color} : {}}
            className={"form-content-star" + (highlight ? " form-content-star-selected" : "")}
            style={isMobileLayout ? 
                {width: `${(5-(Math.floor(starCount / 3)))*12}px`} :
                {width: "48px"}
            }
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <polygon points="12,2 15,9 22,9 17,14 19,21 12,17 5,21 7,14 2,9 9,9" />
        </svg>
    
    )
}